module.exports = __webpack_public_path__ + "img/img11.853a731a.svg";